import {getCart} from 'b2b-plus/utils';

class B2BPlusCartCount extends HTMLElement {
  constructor() {
    super();

    this.cartEvents = ['b2b:cart-saved', 'b2b:product-removed', 'b2b:quick-add-added'];
    
    this.cartEvents.forEach(event => {
      document.addEventListener(event, () => {
        this.getCartCount().then((count) => {
          if (count > 0) {
            this.removeAttribute('hidden');
          } else {
            this.setAttribute('hidden', '');
          }
          this.textContent = count;
        });
      });
    });

    // IndexedDB writes call `notifyCartStorageChanged` (BroadcastChannel only) — e.g. writes
    // from other tabs — without dispatching the document events above. Keep the bubble in sync.
    if (typeof BroadcastChannel === 'function') {
      try {
        this._b2bCartBroadcast = new BroadcastChannel('b2b-plus-cart');
        this._b2bCartBroadcast.addEventListener('message', (ev) => {
          if (ev?.data?.type !== 'cart-updated') return;
          this.getCartCount().then((count) => {
            if (count > 0) {
              this.removeAttribute('hidden');
            } else {
              this.setAttribute('hidden', '');
            }
            this.textContent = count;
          });
        });
      } catch {
        /* ignore */
      }
    }
  }

  async connectedCallback() {
    await this.addCartCount();
  }

  async getCartCount() {
    try {
      const cart = await getCart();
      if (!cart || typeof cart !== 'object' || Array.isArray(cart)) return 0;
      return Object.keys(cart).length;
    } catch {
      return 0;
    }
  }

  async addCartCount() {
    const count = await this.getCartCount();
    if (count > 0) {
      this.removeAttribute('hidden');
    } else {
      this.setAttribute('hidden', '');
    }
    this.textContent = count;
  }
}

customElements.define('b2b-plus-cart-count', B2BPlusCartCount);